import { Hidden } from '@mui/material';
import React from 'react';
import Pagination from 'react-js-pagination';

const PaginatedDeviceTable = ({ 
  devices, 
  selectedDevices, 
  onDeviceSelect, 
  itemsPerPage,
}) => {
  const [currentPage, setCurrentPage] = React.useState(1);
  
  // Calculate total items
  const totalItemsCount = devices.length;
  
  // Get current page data
  const getCurrentPageItems = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return devices.slice(startIndex, endIndex);
  };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div>
      <div className="table-responsive" style={{ maxHeight: "280px", overflow:"hidden" }}>
        <table className="table table-hover table-wrap mb-0">
          <thead>
            <tr>
              <th>CareWindow User</th>
              <th>Device S/N</th>
              <th>Selected</th>
            </tr>
          </thead>
          <tbody>
            {getCurrentPageItems().map((device) => (
              <tr key={device.id}>
                <td>{device.name}</td>
                <td>{device.serialNo}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedDevices.includes(device.id)}
                    onChange={() => onDeviceSelect(device.id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {/* Pagination - Reduced size */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'flex-end',
        marginTop: '10px',
        paddingRight: '10px',
        marginBottom: '10px'
      }}>
        <Pagination
          activePage={currentPage}
          itemsCountPerPage={itemsPerPage}
          totalItemsCount={totalItemsCount}
          pageRangeDisplayed={3}
          onChange={handlePageChange}
          itemClass="page-item"
          linkClass="page-link"
          innerClass="pagination pagination-sm mb-0"
          prevPageText="&lsaquo;"
          nextPageText="&rsaquo;"
        />
      </div>
    </div>
  );
};

export default PaginatedDeviceTable;